module.exports = __webpack_public_path__ + "img/fm-f-Path 59 Copy@3x.30323db9.png";